<template>
  <v-card>
    <!-- tab control -->
    <v-card class="d-flex justify-space-around align-center">
      <div bottom class="text-h5">Avance de Ventas y Despachos</div>
    </v-card>
    <!-- tab0 list -->
    <v-card-text>
      <v-card>
        <!-- advanced filter -->
        <v-toolbar>
          <v-autocomplete
            label="Campaña"
            :items="campaignItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="code"
            item-value="url"
            v-model="selectedCampaign"
            return-object
            @change="campaignSelected($event)"
            ref="campaignAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('campaignAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Estructura Comercial"
            :items="campaignItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="code"
            item-value="url"
            v-model="selectedStructure"
            return-object
            @change="structureSelected($event)"
            ref="structureAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('structureAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Vendedor"
            :items="salesmanItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="url"
            v-model="selectedSalesman"
            return-object
            @change="salesmanSelected($event)"
            ref="salesmanAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('salesmanAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Distribuidor"
            :items="dealerItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="name"
            item-value="url"
            v-model="selectedDealer"
            return-object
            @change="dealerSelected($event)"
            ref="dealerAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('dealerAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Cultivo"
            :items="cropItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="url"
            v-model="selectedCrop"
            return-object
            @change="cropSelected($event)"
            ref="cropAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('cropAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Columna Estimados"
            :items="estimationColumnsItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="code"
            v-model="selectedEstimationColumn"
            return-object
            @change="estimationColumnSelected($event)"
            ref="estimationColumnAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('estimationColumnAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Categoría de Cliente"
            :items="clientCategoryItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="id"
            return-object
            @change="clientCategorySelected($event)"
            ref="clientCategoryAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('clientCategoryAutocomplete')"
          ></v-autocomplete>
          <v-progress-linear
            :active="loading"
            indeterminate
            absolute
            bottom
          ></v-progress-linear>
        </v-toolbar>
      </v-card>
      <div v-show="pivotLoaded" id="pivot-container" class="mt-2"></div>
    </v-card-text>
  </v-card>
</template>
<script>
import WebDataRocks from "webdatarocks";
import "webdatarocks/webdatarocks.min.css";
import "webdatarocks/webdatarocks.toolbar";
import wdrEs from "@/assets/webDataRocksEs.json";
import XLSX from "xlsx";

export default {
  name: "SalesReport",

  components: {
    //
  },

  data() {
    return {
      editMode: "show",
      campaignItems: [],
      cropItems: [],
      estimationColumnsItems: [],
      salesmanItems: [],
      clientCategoryItems: [],
      dealerItems: [],
      filterCampaign: null,
      filterStructure: null,
      filterCrop: null,
      filterEstimationClolumn: null,
      filterSalesman: null,
      filterClientCategory: null,
      filterDealer: null,
      selectedCampaign: null,
      selectedStructure: null,
      selectedCrop: null,
      selectedEstimationColumn: null,
      selectedSalesman: null,
      selectedDealer: null,
      pivot: null,
      pivotLoaded: false,
      loading: true,
      lastEndpoint: null,
      downloading: false
    };
  },

  methods: {
    //Reading data from API method.
    async readDataFromAPI() {
      try {
        this.loading = true;
        if (
          this.filterCampaign &&
          this.filterStructure &&
          this.filterCrop &&
          this.filterEstimationClolumn
        ) {
          this.lastEndpoint =
            "/data/sales_download/" +
            this.filterCampaign.id.toString() +
            "/" +
            this.filterStructure.id.toString() +
            "/" +
            this.filterCrop.id.toString() +
            "/" +
            /* eslint-disable */
            (this.filterSalesman ? this.filterSalesman.salesman_id.toString() : "0") +
            "/" +
            /* eslint-disable */
            (this.filterDealer ? this.filterDealer.dealer_id.toString() : "0") +
            "/" +
            /* eslint-disable */
            (this.filterClientCategory ? this.filterClientCategory.id.toString() : "0") +
            "/0";

          let endpoint =
            "/data/sales_report/" +
            this.filterCampaign.id.toString() +
            "/" +
            this.filterStructure.id.toString() +
            "/" +
            this.filterCrop.id.toString() +
            "/" +
            this.filterEstimationClolumn.code +
            "/" +
            /* eslint-disable */
            (this.filterSalesman ? this.filterSalesman.salesman_id.toString() : "-1") +
            "/" +
            /* eslint-disable */
            (this.filterDealer ? this.filterDealer.dealer_id.toString() : "-1") +
            "/" +
            /* eslint-disable */
            (this.filterClientCategory ? this.filterClientCategory.id.toString() : "0");

          let response = await this.$bRoot.search(endpoint);
          let title =
            this.filterCampaign.description +
            ", Estructura Comercial: " + this.filterStructure.description +
            ", Cultivo: " +
            this.filterCrop.description +
            ", Columna Estimados: " +
            this.filterEstimationClolumn.id.toString()
            if (this.filterSalesman) {
              title = title + ", Vendedor: " + this.filterSalesman.description;
            }
            if (this.filterDealer) {
              title = title + ", Distribuidor: " + this.filterDealer.name;
            }
            if (this.filterClientCategory) {
              title = title + ", Categoría: " + this.filterClientCategory.description;
            }
            " (" +
            this.$moment().format("DD/MM/YYYY h:mm a") +
            ")";
          await this.loadPivotTable(response.data, title);
          this.pivotLoaded = true;
        } else {
          this.pivotLoaded = false;
          this.unloadPivotTable();
        }
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      } finally {
        this.loading = false;
      }
    },

    clearAutocomplete(field) {
      this.$refs[field].internalValue = [];
      switch (field) {
        case "campaignAutocomplete":
          this.filterCampaign = null;
          break;
        case "structureAutocomplete":
          this.filterStructure = null;
          break;
        case "estimationColumnAutocomplete":
          this.filterEstimationClolumn = null;
          break;
        case "cropAutocomplete":
          this.filterCrop = null;
          break;
        case "salesmanAutocomplete":
          this.filterSalesman = null;
          break;
        case "clientCategoryAutocomplete":
          this.filterClientCategory = null;
          break;
        case "dealerAutocomplete":
          this.filterDealer = null;
          break;
      }
      this.readDataFromAPI();
    },

    campaignSelected(item) {
      this.filterCampaign = item;
      this.loadColumns();
      this.readDataFromAPI();
    },

    structureSelected(item) {
      this.filterStructure = item;
      this.loadSalesmans();
      this.loadDealers();
      this.readDataFromAPI();
    },

    estimationColumnSelected(item) {
      this.filterEstimationClolumn = item;
      this.readDataFromAPI();
    },

    cropSelected(item) {
      this.filterCrop = item;
      this.loadDealers();
      this.readDataFromAPI();
    },

    salesmanSelected(item) {
      this.filterSalesman = item;
      this.readDataFromAPI();
    },

    clientCategorySelected(item) {
      this.filterClientCategory = item;
      this.readDataFromAPI();
    },

    dealerSelected(item) {
      this.filterDealer = item;
      this.readDataFromAPI();
    },

    async loadPivotTable(data, title) {
      /*Crear Pivot Table*/
      this.pivot = new WebDataRocks({
        container: "#pivot-container",
        toolbar: true,
        beforetoolbarcreated: this.customizeToolbar,
        reportcomplete: this.expandsPivotTable,
        global: {
          localization: wdrEs
        },
        report: {
          options: {
            grid: {
              type: "compact",
              showHeaders: false,
              showTotals: "on",
              showGrandTotals: "off",
              title: title
            },
            configuratorButton: false
          },
          dataSource: {
            data: data
          },
          slice: {
            rows: [
              { uniqueName: "director" },
              { uniqueName: "gtc" },
              { uniqueName: "rtc" },
              { uniqueName: "lider" }
            ],
            columns: [{ uniqueName: "Measures" }],
            measures: [
              {
                uniqueName: "venta_anterior",
                caption: "Ventas Camp. Anterior",
                individual: true,
                formula: 'IF("metrica_id" == 1, "valor", 0)',
                aggregation: "sum",
                format: "f_valor"
              },
              {
                uniqueName: "estimado",
                caption: "Venta Estimada",
                individual: true,
                formula: 'IF("metrica_id" == 2, "valor", 0)',
                aggregation: "sum",
                format: "f_valor"
              },
              {
                uniqueName: "meta",
                caption: "Meta",
                individual: true,
                formula: 'IF("metrica_id" == 3, "valor", 0)',
                aggregation: "sum",
                format: "f_valor"
              },
              {
                uniqueName: "venta",
                caption: "Venta",
                individual: true,
                formula: 'IF("metrica_id" == 4, "valor", 0)',
                aggregation: "sum",
                format: "f_valor"
              },
              {
                uniqueName: "avance_venta",
                caption: "Venta s/Meta",
                formula: '"venta" / "meta"',
                format: "f_porcentaje"
              },
              {
                uniqueName: "despacho",
                caption: "Despachado",
                individual: true,
                formula: 'IF("metrica_id" == 5, "valor", 0)"',
                aggregation: "sum",
                format: "f_valor"
              },
              {
                uniqueName: "avance_despacho",
                caption: "Despachado s/Venta",
                formula: '"despacho" / "venta"',
                format: "f_porcentaje"
              },
              {
                uniqueName: "venta_usd",
                caption: "Venta en USD",
                individual: true,
                formula: 'IF("metrica_id" == 6, "valor", 0)',
                aggregation: "sum",
                format: "f_importe"
              },
              {
                uniqueName: "comision_porcentual",
                caption: "Comisión",
                formula: '"comision_usd" / "venta_usd"',
                format: "f_porcentaje"
              },
              {
                uniqueName: "comision_usd",
                caption: "Comisión USD",
                individual: true,
                formula: 'IF("metrica_id" == 7, "valor", 0)',
                aggregation: "sum",
                format: "f_importe",
              },
              {
                uniqueName: "incentivo_porcentual",
                caption: "Incentivo",
                formula: '"incentivo_usd" / "venta_usd"',
                format: "f_porcentaje"
              },
              {
                uniqueName: "incentivo_usd",
                caption: "Incentivo USD",
                individual: true,
                formula: 'IF("metrica_id" == 8, "valor", 0)',
                aggregation: "sum",
                format: "f_importe",
              },
              {
                uniqueName: "comision_total_usd",
                caption: "Comisión Total USD",
                formula: '"comision_usd" + "incentivo_usd"',
                format: "f_importe"
              },
              {
                uniqueName: "facturado_usd",
                caption: "Facturado USD",
                individual: true,
                formula: 'IF("metrica_id" == 9, "valor", 0)',
                aggregation: "sum",
                format: "f_importe"
              },
              {
                uniqueName: "avance_facturado",
                caption: "Facturado USD s/Venta USD",
                formula: '"facturado_usd" / "venta_usd"',
                format: "f_porcentaje"
              }
            ],
            expands: {
              expandAll: false
            }
          },
          formats: [
            {
              name: "f_importe",
              thousandsSeparator: ".",
              decimalSeparator: ",",
              decimalPlaces: 2,
              currencySymbol: "",
              currencySymbolAlign: "left",
              nullValue: "",
              textAlign: "right",
              isPercent: false
            },
            {
              name: "f_valor",
              thousandsSeparator: ".",
              decimalPlaces: 0,
              currencySymbol: "",
              currencySymbolAlign: "left",
              nullValue: "",
              textAlign: "right",
              isPercent: false
            },
            {
              name: "f_porcentaje",
              thousandsSeparator: ".",
              decimalPlaces: 2,
              decimalSeparator: ",",
              currencySymbol: "",
              currencySymbolAlign: "left",
              nullValue: "",
              textAlign: "right",
              isPercent: true
            }
          ]
        }
      });
    },

    unloadPivotTable() {
      this.pivot = null;
    },

    customizeToolbar(toolbar, sr = this) {
      var tabs = toolbar.getTabs();
      tabs.forEach((tab, index) => {
        if (!(tab.id == "wdr-tab-fullscreen" || tab.id == "wdr-tab-export")) {
          delete tabs[index];
        }
      });
      toolbar.getTabs = function(
          ds = (() => {sr.DownloadSales()}),
          ea = (() => {sr.expandAllPivotTable()}),
        ){
        tabs.unshift({
            id: "wdr-tab-download-sales",
            title: "Ventas",
            icon: this.icons.export_excel,
            handler: ds
        });
        tabs.unshift({
            id: "wdr-tab-expand-all",
            title: "Expandir",
            icon: '<i class="mdi mdi-24px mdi-expand-all-outline"></i>',
            handler: ea
        });

        return tabs;
      };
    },

    expandsPivotTable() {
      this.pivot.expandData("director");
      this.pivot.expandData("gtc");
    },

    expandAllPivotTable() {
      this.pivot.expandAllData();
    },

    async loadColumns() {
      this.estimationColumnsItems = [];
      let columns = null,
        newColumn = null,
        defaultColumn = null;

      //load columns
      columns = await this.$bRoot.search(
        "/data/estimations_columns",
        null,
        "number",
        "campaign__id=" + this.filterCampaign.id.toString()
      );

      if (columns.data.count !== 12) {
        this.canEdit = false;
        throw "Error recuperando configuración de columnas para " +
          this.filterCampaign.description.toString() +
          " contacte al administrador";
      }

      columns.data.results.map(item => {
        newColumn = {
          id: item.number,
          code: "col" + item.number.toString(),
          description: item.description
        };
        this.estimationColumnsItems.push(newColumn);
        if (
          this.$moment().isBetween(
            this.$moment(item.editable_from),
            this.$moment(item.editable_to)
          ) &&
          !defaultColumn
        ) {
          defaultColumn = newColumn;
        }
      });

      //set default
      if (defaultColumn) {
        this.selectedEstimationColumn = defaultColumn.code;
        this.filterEstimationClolumn = defaultColumn;
      }
    },

    async loadSalesmans() {
      this.salesmanItems = [];
      this.selectedSalesman = null;
      this.filterSalesman = null;
      let salesmans = null;
      if (this.filterStructure) {
        salesmans = await this.$bRoot.search(
          "/data/salesman_campaign_hierarchy",
          null,
          null,
          "campaign__id=" + this.filterStructure.id.toString()
        );
        this.salesmanItems = salesmans.data.results;
      }
    },

    async loadDealers() {
      this.dealerItems = [];
      this.filterDealer = null;
      this.selectedDealer = null;
      let dealers = null;
      if (this.filterStructure && this.filterCrop) {
        dealers = await this.$bRoot.search(
          "/data/dealers_campaign_crop_hierarchy" +
            "/" +
            this.filterStructure.id.toString() +
            "/" +
            this.filterCrop.id.toString(),
          null,
          null
        );
        if (dealers.data) {
          this.dealerItems = dealers.data;
        }
      }
    },

    async DownloadSales() {
      try {
        this.loading = true;
        if (this.lastEndpoint) {
          // eslint-disable-next-line
          let raw = await this.$bRoot.search(this.lastEndpoint, null, null, null, null);
          if (raw.data) {
            let datosWS = XLSX.utils.json_to_sheet(raw.data);
            let wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, datosWS, "ventas");
            XLSX.writeFile(wb, "ventas.xlsx");
          }
        }
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      } finally {
        this.loading = false;
      }
    },
  },

  async mounted() {
    var main_container = document.getElementById("app");
    main_container.classList.remove("home");

    this.current_level = this.$bRoot.auth.current_level;
    let campaigns = null,
      crops = null,
      index = -1;

    try {
      //load campaigns
      campaigns = await this.$bRoot.search("/data/campaigns", null, "-code");
      this.campaignItems = campaigns.data.results;

      //set default
      let defaultCampaignId = this.$bRoot.getUserParam("defaultCampaignId");
      index = this.campaignItems.findIndex(item => item.id == defaultCampaignId);
      if (index == -1) {
        index = this.campaignItems.findIndex(item => item.current === true);
      }
      if (index !== -1) {
        this.selectedCampaign = this.campaignItems[index].url;
        this.filterCampaign = this.campaignItems[index];
        this.selectedStructure = this.campaignItems[index].url;
        this.filterStructure = this.campaignItems[index];
      }

      //load crops
      crops = await this.$bRoot.search("/data/crops", null, "description");
      this.cropItems = crops.data.results;

      //set default
      let defaultCropId = this.$bRoot.getUserParam("defaultCropId");
      index = this.cropItems.findIndex(item => item.id === defaultCropId);
      if (index !== -1) {
        this.selectedCrop = this.cropItems[index].url;
        this.filterCrop = this.cropItems[index];
      }

      //clientCategories
      let clientCategories = await this.$bRoot.searchAll(
        "/data/categories",
        null,
        "description"
      );
      this.clientCategoryItems = clientCategories;

      await this.loadColumns();

      //Salesmans and Dealers
      await this.loadSalesmans();
      await this.loadDealers();

      this.readDataFromAPI();
    } catch (error) {
      if (!this.$bRoot.errors) {
        this.$bRoot.setError(error);
      }
    } finally {
      this.loading = false;
    }
  }
};
</script>
<style>
.wdr-credits {
  display: none;
}
</style>
